'use client';

import { FC, PropsWithChildren, useState } from 'react';
import { AppShell } from '@mantine/core';

// internal
import Header from './header/Header';
import MainMenu from './menu/Main';
import NavMenu from './menu/Nav';
import NavConsoleMenu from './menu/NavConsole';

interface LayoutProps {
  type: 'main' | 'manage';
  subType?: 'console';
}

const Layout: FC<PropsWithChildren<LayoutProps>> = (props) => {
  const [hideNavBar, setHideNavBar] = useState<boolean>(false);

  const onClickHideNavbar = () => {
    setHideNavBar(!hideNavBar);
  };

  return (
    <AppShell
      header={{ height: props.type === 'manage' ? 60 : props.subType === 'console' ? 120 : 110 }}
      navbar={{
        width: (props.type === 'manage' || props.subType === 'console') && !hideNavBar ? 200 : 0,
        breakpoint: 'sm',
      }}
      padding="md"
    >
      <AppShell.Header>
        <Header
          onClickHide={onClickHideNavbar}
          backButton={props.type === 'manage'}
          menuButton={props.type === 'manage'}
        />
        {props.type === 'main' && <MainMenu />}
      </AppShell.Header>
      {props.type === 'manage' && !hideNavBar && (
        <AppShell.Navbar p="xs">
          <NavMenu />
        </AppShell.Navbar>
      )}

      {props.subType === 'console' && (
        <AppShell.Navbar p="xs">
          <NavConsoleMenu />
        </AppShell.Navbar>
      )}

      <AppShell.Main>{props.children}</AppShell.Main>
    </AppShell>
  );
};

export default Layout;
